export default __webpack_public_path__ + "static/media/glow.df166240.svg";